export default __webpack_public_path__ + "media/images/badge-level1-size34-d68e2b4188ff004c5b4d20dbbaa4af31.png";